/**
 * redux actions and action creaters, only for user related functionalites
 */

import {
  USER_DETAILS_SUCCESS,
  RESET_USER_DETAILS,
  USER_DETAILS_LOADING,
  USER_DETAILS_FAILED,
  PUNCH_DETAILS_SUCCESS,
  RESET_AUTH_DETAILS,
  AUTH_DETAILS_FAILED,
  AUTH_DETAILS_SUCCESS,
  AUTH_DETAILS_LOADING,
  RESET_ID_NOTIFICATION,
  USER_ERRORS,
  IMT_ROLE_DETAILS_LOADING,
  IMT_ROLE_DETAILS_FAILED,
  IMT_ROLE_DETAILS_SUCCESS
} from "../CONSTANTS";
 
import moment from "moment";
import { dateConfig } from "../../pages/Punch/config";
 
import {
  getUserDetails,
  getPunchData,
  getDetailsByEmail,
  getCurrentDayMealPunches,
  getWorkerActivity
} from "../../services";
import {getWorkerIMTimeRole} from '../../services/workerSchedule';
import { delCurrentUser } from "services/firebaseAuthentication";
import { setAuthorizationToken } from "utils";
import { getParamValue, convertStringToArray } from "utils/rcUtils";
// import { getRcArrayParam } from "services/firebase";
import { getProjects } from "./appActions";
import { MEAL, DELETED } from "../../pages/Punch/constants";
// import * as RootNavigation from "../navigation/RootNavigation";

const getUserLoading = () => ({
  type: USER_DETAILS_LOADING,
});
const getUserSuccess = (payload) => ({
  type: USER_DETAILS_SUCCESS,
  payload,
});
const getUserFailed = (payload) => ({
  type: USER_DETAILS_FAILED,
  payload,
});
const resetUserDetailsAction = () => ({
  type: RESET_USER_DETAILS,
});

export const setAuthLoading = () => ({
  type: AUTH_DETAILS_LOADING,
});

export const setImtRoleLoading = () => ({
  type: IMT_ROLE_DETAILS_LOADING,
});

const getAuthSuccess = (payload) => ({
  type: AUTH_DETAILS_SUCCESS,
  payload,
});
const getAuthFailed = (payload) => ({
  type: AUTH_DETAILS_FAILED,
  payload,
});

const getImtRoleFailed = (payload) =>({
  type: IMT_ROLE_DETAILS_FAILED,
  payload
})

const getIMTRoleSuccess = (payload) =>({
  type: IMT_ROLE_DETAILS_SUCCESS,
  payload
})

const resetAuthDetailsAction = () => ({
  type: RESET_AUTH_DETAILS,
});

const getPunchSuccess = (payload) => ({
  type: PUNCH_DETAILS_SUCCESS,
  payload,
});

/**
 * reset ID notification
 */
export const resetIdNotification = () => ({
  type: RESET_ID_NOTIFICATION,
});

/**
 * fn for fetching user details with ID.
 * @param {string}
 * @return: {Object} containing user details
 */
// export const getUser = (empId, history) => (dispatch) => {
export const getUser = (empId, callback) => (dispatch, getState) => {
  console.log("in action: getUser...");
  const { config } = getState().remote;
  let punchAccess = getParamValue(config, "punchAccess");
  punchAccess = convertStringToArray(punchAccess);
  console.log("PunchAccessCountries:",punchAccess);
  dispatch(getUserLoading());
  getUserDetails(empId)
    .then(async (data) => {
      let resError = null,
        resUser = null,
        resPunch = null;
      if (!data.exists) {
        dispatch(
          getUserFailed({
            err: "pgHome.errNotFoundWorker",
            notification: false,
          })
        );
        resError = USER_ERRORS.NOT_FOUND;
        // return false;
      } else {
        const workerRoles = await getWorkerIMTimeRole(empId);
        const user = { ...data.data(), workerId: data.id };
        resUser = user;
        // const punchAccessCountries = getPunchAccessFromRc();
        // const punchAccessCountries = getRcArrayParam("punchAccess");
        const punchAccessCountries = punchAccess;
        if (user.hasOwnProperty("isDeleted") && user.isDeleted) {
          // worker is inActive
          dispatch(
            getUserFailed({
              err: "pgHome.errNotFoundWorker",
              notification: false,
            })
          );
          resError = USER_ERRORS.DELETED;
          resUser = null;
        } else if (
          !(user.hasOwnProperty("isActiveWorker") && user.isActiveWorker)
        ) {
          // worker is inActive
          dispatch(
            getUserFailed({
              err: "pgHome.errInactiveWorker",
              notification: false,
            })
          );
          resError = USER_ERRORS.INACTIVE;
          resUser = user;
        }
        else if (
          workerRoles && workerRoles.hasOwnProperty("isScannerOnly") && workerRoles.isScannerOnly
        ) {
          // worker is restricted to mobile only
          dispatch(
            getUserFailed({
              err: "other.errWebRestricted",
              notification: false,
            })
          );
          resError = "Restricted To Web";
          resUser = user;
        }  
        else if (
          !(
            user.hasOwnProperty("country") &&
            punchAccessCountries.includes(user.country)
          )
        ) {
          // worker country is not enabled for punching
          dispatch(
            getUserFailed({
              err: "pgHome.errPunchDisabled",
              notification: false,
            })
          );
          resError = USER_ERRORS.PUNCH_DISABLED;
          resUser = user;
        } else {
          dispatch(getUserSuccess(user));
          dispatch(getProjects(user.country));
          // Get last punch details
          if (
            Object.prototype.hasOwnProperty.call(user, "lastPunchId") &&
            user.lastPunchId
          ) {
            //dispatch(getPunch(user.lastPunchId));
            try {
              const workerActivityDoc = await getWorkerActivity(user.workerId);
              const workerActivity = {...workerActivityDoc.data()};
              //let doc = await getPunchData(user.lastPunchId);
              if (
                Object.prototype.hasOwnProperty.call(workerActivity, "lastPunchId") &&
                workerActivity.lastPunchId
              ){
                const doc = await getPunchData(workerActivity.lastPunchId);          
                const punch = { punchId: doc.id, ...doc.data() };
                
                const endTime= moment().endOf('day').format(dateConfig.format4);
                const startTime = moment().startOf('day').format(dateConfig.format4);

              // const currentDayMealPunchFlag = await getCurrentDayMealPunches(punch.workerId,startTime , endTime);
                
                console.log("lastPunch action",punch)
                dispatch(getPunchSuccess(punch));
                resPunch = punch;
                // .then((doc) => {
                //   const punch = { punchId: doc.id, ...doc.data() };
                //   resPunch = punch;
                //   dispatch(getPunchSuccess(punch));
                // if (
                //   punch.activityGroup === MEAL &&
                //   punch.status != DELETED &&
                //   !punch.outTS &&
                //   !punch.outLocalTS
                // ) {
                //   setMealModalVisible();
                // } else {
                //   callback && callback(null, {user, punch});
                // }
                // })
                }
              } catch (err) {
                resPunch = null;
                console.log("err in submitHandler...", err);
              }
            }
            // if (history) history.push("/review"); //route to new page on success
            // else if (callback) callback(null, {user, punch:null});
            //  else {
            //    callback();
            //  }
        }
      }
      if (callback) callback(resError, { user: resUser, punch: resPunch });
    })
    .catch((err) => {
      let resError = USER_ERRORS.UNABLE_TO_LOAD,
        resUser = null,
        resPunch = null;
      console.error("err in submitHandler...", err);
      dispatch(
        getUserFailed({
          err: "pgHome.errLoadingWorker",
          notification: false,
        })
      );
      if (callback) callback(resError, { user: resUser, punch: resPunch });
    });
};

export const getUserImtRole = (workerId) => (dispatch) => {
  console.log("in userActions > getUserImtRole called...");
  dispatch(setImtRoleLoading());
  getWorkerIMTimeRole(workerId).then((data) => {
    console.log("in userActions > getUserImtRole",  data);
    if(!data || !Object.keys(data).length >0){
      dispatch(getImtRoleFailed("worker IMTime role not found"))
    } else {
      dispatch(getIMTRoleSuccess(data));
    }
  }).catch(err => {
    dispatch(getImtRoleFailed("worker IMTime role not found"))
  })
}

export const getUserByEmail = (googleUser) => (dispatch) => {
  console.log("in userActions > getUserByEmail called...");
  const empEmail = googleUser.email.toLowerCase();
  dispatch(setAuthLoading());
  getDetailsByEmail(empEmail)
    .then((doc) => {
      if (!doc) {
        dispatch(getAuthFailed("pgHome.errNotFoundAuth"));
        // Delete user account.
        delCurrentUser();
      } else {
        const user = { ...doc.data(), workerId: doc.id };
        if (
          !Object.prototype.hasOwnProperty.call(user, "isActiveWorker") ||
          user.isActiveWorker
        ) {
          console.log(
            "All auth tests passed. adding user to store.",
            user,
            googleUser
          );
          // persist authentication across user sessions
          setAuthorizationToken(googleUser.uid);
          // add user details in redux store
          // dispatch(getProjects(user.country))
          dispatch(getAuthSuccess({ user, googleUser }));
        } else {
          // worker is inActive
          console.log("User is inactive........");
          dispatch(getAuthFailed("pgHome.errInactiveAuth"));
        }
      }
    })
    .catch((err) => {
      console.error("userActions > getUserByEmail > err =====", err);
      dispatch(
        getAuthFailed("System error while searching for employee details.")
      );
    });
};

/**
 * reset app state for new user.
 */
export const resetUserDetails = () => (dispatch) => {
  console.log("in action: resetUserDetails...");
  dispatch(resetUserDetailsAction());
};

/**
 * reset app state for new authenticated user.
 */
export const resetAuthDetails = () => (dispatch) => {
  console.log("in action: resetAuthDetails...");
  dispatch(resetAuthDetailsAction());
};

/**
 * fn for fetching punch details with ID.
 * @param {string}
 * @return: {Object} containing punch details
 */
export const getPunch = (punchId) => (dispatch) => {
  console.log("in userActions: getPunch...");
  getPunchData(punchId)
    .then((data) => {
      if (data.exists) {
        const punch = { ...data.data(), punchId: data.id };
        dispatch(getPunchSuccess(punch));
      }
    })
    .catch((err) => {
      console.error("in userActions > getPunch, err===", err);
    });
};
